class AnnouncementBar extends HTMLElement {
  constructor() {
    super()

    this.swiperEl = this.querySelector('swiper-container')
    this._nostoObserver = null
  }

  connectedCallback() {
    this.swiperEl.addEventListener('swiperslidechangetransitionend', () => {
      this.setSlidesA11y(this.swiperEl)
    })

    this._checkForInjectedNostoBanner()
  }

  _checkForInjectedNostoBanner() {
    if (document.getElementById('nosto-announcement')) {
      this._swapNostoArrows()
      this._dispatchReadyEvent()
      return
    }
    if (this._nostoObserver) return
    this._nostoObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        const { target } = mutation
        if (
          target.classList.contains('nosto-slider') &&
          target.classList.contains('slick-initialized')
        ) {
          this._swapNostoArrows()
          this._dispatchReadyEvent()
          this._nostoObserver.disconnect()
          this._nostoObserver = null
          return
        }
      }
    })
    this._nostoObserver.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  // ponytail: SVG mirrors snippets/icon-hero-arrow.liquid — keep in sync if that changes.
  _swapNostoArrows() {
    this.querySelectorAll('[data-slider-back], [data-slider-next]').forEach((el) => {
      const svg = el.querySelector('svg')
      if (!svg) return
      const left = el.hasAttribute('data-slider-back')
      svg.outerHTML =
        `<svg class="icon-hero-arrow" width="14" height="14" viewBox="0 0 24 24"` +
        ` xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"` +
        (left ? ` style="transform: scaleX(-1); transform-origin: center;"` : ``) +
        `><path d="M6 5 L18 12 L6 19 Z" fill="currentColor" stroke="currentColor"` +
        ` stroke-width="3" stroke-linejoin="round" stroke-linecap="round"/></svg>`
    })
  }

  _dispatchReadyEvent() {
    const mainMenu = document.querySelector('main-menu')
    if (mainMenu) {
      mainMenu.dispatchEvent(
        new CustomEvent('announcement-bar::ready', { bubbles: true })
      )
    }
  }

  disconnectedCallback() {
    if (this._nostoObserver) {
      this._nostoObserver.disconnect()
      this._nostoObserver = null
    }
  }

  setSlidesA11y(swiperEl) {
    swiperEl.querySelectorAll('swiper-slide').forEach((slide) => {
      if (slide.classList.contains('swiper-slide-active')) {
        slide.removeAttribute('inert')
      } else {
        slide.setAttribute('inert', '')
      }
    })
  }
}
window.customElements.define('announcement-bar', AnnouncementBar)
